import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
import SignOut from '../pages/SignOut';
import Repository from '../pages/Repository';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';

import Dashboard from '../pages/Dashboard';
import Agenda from '../pages/Agenda';
import Agendas from '../pages/Agendas';
import AgendaBusca from '../pages/AgendaBusca';
import AgendaEnvioConfirmacao from '../pages/AgendaEnvioConfirmacao';
import Paciente from '../pages/Paciente';
import PacienteUnificacao from '../pages/PacienteUnificacao';
import Aniversariantes from '../pages/Relatorios/Aniversariantes';
import PacienteCadastro from '../pages/PacienteCadastro';
import CartaoSaude from '../pages/CartaoSaude';
import CartaoSaudeDetalhe from '../pages/CartaoSaudeDetalhe';
import CartaoSaudeImpressao from '../pages/CartaoSaudeImpressao';
import AssinaturaDigital from '../pages/CartaoSaude/AssinaturaDigital';
import Profile from '../pages/Profile';
import Nota from '../pages/Nota';
import Exame from '../pages/Exame';
import ExamesSolicitados from '../pages/ExamesSolicitados';
import Caixa from '../pages/Caixa';
import Procedimento from '../pages/Procedimento';
import AgendaCadastro from '../pages/AgendaCadastro';
import DiaNaoAgendar from '../pages/AgendaCadastro/DiaNaoAgendar';
import AgendaAtendimento from '../pages/AgendaAtendimento';
import PacienteAtendimentoAlvaro from '../pages/PacienteAtendimentoAlvaro';
import PacienteAtendimento from '../pages/PacienteAtendimento';
import Usuario from '../pages/Usuario/Usuario';
import Medico from '../pages/Usuario/Medico';
import ContratoMedico from '../pages/Usuario/Contrato';
import AniversariantesUsuario from '../pages/Relatorios/AniversariantesUsuario';
import Configuracao from '../pages/Configuracao';

import FechamentoCaixa from '../pages/Relatorios/FechamentoCaixa';
import FechamentoDia from '../pages/Relatorios/FechamentoDia';
import FechamentoConferencia from '../pages/Relatorios/FechamentoConferencia';
import ProcedimentosRealizados from '../pages/Relatorios/ProcedimentosRealizados';
import ProcedimentosRealizadosValor from '../pages/Relatorios/ProcedimentosRealizadosValor';
import ProcedimentosRealizadosConvenio from '../pages/Relatorios/ProcedimentosRealizadosConvenio';
import QuantidadeProcedimentos from '../pages/Relatorios/QuantidadeProcedimentos';
import ResumoGerencial from '../pages/Relatorios/ResumoGerencial';
import ResumoCartaoSaude from '../pages/Relatorios/CartaoSaude';
import CartaoSaudeListagem from '../pages/Relatorios/CartaoSaudeListagem';

import Despesas from '../pages/Relatorios/Despesas';
import DespesasResumo from '../pages/Relatorios/DespesasResumo';

import Cobranca from '../pages/Relatorios/Cobranca';
import CobrancasRealizadas from '../pages/Relatorios/Cobranca/CobrancasRealizadas';

import SemPermissao from '../pages/SemPermissao';
import Perfil from '../pages/Perfil';
import ModeloDocumento from '../pages/Modelo/Documento';
import ModeloMensagem from '../pages/Modelo/Mensagem';
import EmConstrucao from '../pages/EmConstrucao';
import ResumoCobrancas from '../pages/Relatorios/Cobranca/ResumoCobrancas';
import Cobrancas31 from '../pages/Relatorios/Cobranca/Cobrancas31';
import CobrancasMes from '../pages/Relatorios/Cobranca/CobrancasMes';

import CadastroContrato from '../pages/Contratos';

import ConferenciaExamesAlvaro from '../pages/Relatorios/ConferenciaExamesAlvaro';
import LucroExamesAlvaro from '../pages/Relatorios/LucroExamesAlvaro';
import PalavraBloqueada from '../pages/PalavrasBloqueadas';

import ImpressaoDocumento from '../pages/ImpressaoDocumento';
import PedidoExamesBusca from '../pages/PedidoExamesBusca';
import PedidoEncaminhamentoBusca from '../pages/PedidoEncaminhamentoBusca';
import PagarOutraClinica from '../pages/Relatorios/PagarOutraClinica';
import ReceberOutraClinica from '../pages/Relatorios/ReceberOutraClinica';
import Produtividade from '../pages/Relatorios/Produtividade';
import ProdutividadeDetalhe from '../pages/Relatorios/Produtividade/ProdutividadeDetalhe';
import FechamentoParceiro from '../pages/Relatorios/FechamentoParceiro';
import AtendimentoParticular from '../pages/Relatorios/AtendimentoParticular';
import DashboardAgendamento from '../pages/Relatorios/DashboardAgendamento';
import DashboardMedico from '../pages/Relatorios/DashboardMedico';
import MedicosAgendamentos from '../pages/Relatorios/MedicosAgendamentos';

import GrupoExames from '../pages/GrupoExames';
import ListaOrcamentos from '../pages/ListaOrcamentos';
import Orcamento from '../pages/Orcamento';
import ContratoTratamento from '../pages/Orcamento/Contrato';
import PacoteTratamento from '../pages/PacoteTratamento';
import Whatsapp from '../pages/Whatsapp';
import OutrasReceitas from '../pages/Relatorios/OutrasReceitas';
import AgendamentosSemanal from '../pages/AgendamentosSemanal';
import Encaminhamentos from '../pages/Relatorios/Encaminhamentos';
import MedicoEncaminhamento from '../pages/Medico';
import UnidadeSaude from '../pages/UnidadeSaude';
import PagamentoMedico from '../pages/Relatorios/PagamentoMedico';
import RelatorioNotaFiscal from '../pages/Nota/Relatorio';
import DespesasPagamentoMedico from '../pages/Relatorios/PagamentoMedico/DespesasPagamentoMedico';
import ReciboImpressao from '../pages/Relatorios/PagamentoMedico/Recibo/Recibo';
import RegistroLoginDia from '../pages/Relatorios/RegistroLoginDia';
import ConsumoCartao from '../pages/Relatorios/ConsumoCartao';
import ListaEsperaAtendimento from '../pages/ListaEsperaAtendimento';
import AgendaSalas from '../pages/AgendaSalas';
import Painel from '../pages/Painel';
import AgendaBuscaExport from '../pages/AgendaBuscaExport';
import ProcedimentosAgendadosExport from '../pages/ProcedimentosAgendadosExport';
import ClinicaCadastro from '../pages/ClinicaCadastro';
import SignInBloqueado from '../pages/SignInBloqueado';
import AgendamentosRealizadosDia from '../pages/Relatorios/AgendamentosRealizadosDia';
import AgendamentosWhatsapp from '../pages/Relatorios/AgendamentosWhatsapp';
import PedidoExamesProcedimentos from '../pages/Relatorios/PedidoExamesProcedimentos';
import PedidoExamesQuantidadeProcedimentos from '../pages/Relatorios/PedidoExamesQuantidadeProcedimentos';
import PedidoExamesGerencialValor from '../pages/Relatorios/PedidoExamesGerencialValor';
import PedidoEncaminhamentoQuantidadeProcedimentos from '../pages/Relatorios/PedidoEncaminhamentoQuantidadeProcedimentos';
import PedidoEncaminhamentosGerencialValor from '../pages/Relatorios/PedidoEncaminhamentosGerencialValor';
import PacienteBuscaAvancada from '../pages/Relatorios/PacienteBuscaAvancada';
import ServicosNF from '../pages/ServicosNF';
import ListaCombo from '../pages/ListaCombo';
import PacoteCombo from '../pages/PacoteCombo';
import WhatsappBotPainel from '../pages/WhatsappBotPainel';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={SignIn} />
    <Route path="/signinbloqueado" exact component={SignInBloqueado} />
    <Route path="/forgot-password" component={ForgotPassword} />
    <Route path="/reset-password" component={ResetPassword} />
    <Route path="/sair" component={SignOut} showHeader={false} isPrivate />
    <Route
      path="/emconstrucao"
      titulo="Em Construção"
      component={EmConstrucao}
      isPrivate
    />

    <Route path="/agendas" titulo="Agendas" component={Agendas} isPrivate />
    <Route
      path="/clinicas"
      titulo="Clinicas"
      component={ClinicaCadastro}
      isPrivate
    />
    <Route
      path="/agendamentos"
      titulo="Agendamentos Semanal"
      component={AgendamentosSemanal}
      isPrivate
    />
    <Route path="/agenda/:id" component={Agenda} isPrivate />
    <Route
      path="/agendabusca"
      titulo="Busca na Agenda"
      component={AgendaBusca}
      isPrivate
    />
    <Route
      path="/agendabuscaexport"
      titulo="Agendas - Export"
      component={AgendaBuscaExport}
      isPrivate
    />

    <Route
      path="/procedimentosagendadosexport"
      titulo="Procedimentos Agendados - Export"
      component={ProcedimentosAgendadosExport}
      isPrivate
    />
    <Route
      path="/agendaenvioconfirmacao"
      titulo="Envio de Confirmação Agenda"
      component={AgendaEnvioConfirmacao}
      isPrivate
    />
    <Route
      path="/pedidoexamesbusca"
      titulo="lista de pedidos de exames"
      component={PedidoExamesBusca}
      isPrivate
    />
    <Route
      path="/PedidoEncaminhamentoBusca"
      titulo="lista de pedidos de encaminhamento"
      component={PedidoEncaminhamentoBusca}
      isPrivate
    />
    <Route path="/paciente" titulo="Pacientes" component={Paciente} isPrivate />
    <Route
      path="/pacienteunificacao"
      titulo="Unificação de Pacientes"
      component={PacienteUnificacao}
      isPrivate
    />

    <Route
      path="/aniversariantes"
      titulo="Aniversariantes"
      component={Aniversariantes}
      isPrivate
    />
    <Route
      path="/pacientecadastro/:id"
      component={PacienteCadastro}
      isPrivate
    />

    <Route path="/painel" component={Painel} />
    <Route
      path="/cartaosaude"
      titulo="Cartões"
      component={CartaoSaude}
      isPrivate
    />
    <Route
      path="/cartaosaudedetalhe/:id"
      component={CartaoSaudeDetalhe}
      isPrivate
    />
    <Route
      path="/cartaosaudeimpressao/:id/:tipo"
      titulo="Impressão"
      component={CartaoSaudeImpressao}
      isPrivate
      showHeader={false}
    />
    <Route
      path="/cartaassinatura/:ConCodigo/:PlaCodigo"
      titulo="Assinatura Digital"
      component={AssinaturaDigital}
      isPrivate
      showHeader={false}
      showSideBar={false}
    />
    <Route
      path="/dashboard"
      titulo="Dashboard"
      component={Dashboard}
      isPrivate
    />
    <Route path="/profile" component={Profile} isPrivate />
    <Route path="/repositories/:repository+" component={Repository} />
    <Route path="/notasfiscais" component={Nota} isPrivate showSideBar />
    <Route
      path="/relatorionotasfiscais"
      component={RelatorioNotaFiscal}
      isPrivate
      showSideBar
    />
    <Route path="/exame" component={Exame} isPrivate />
    <Route
      path="/examessolicitados"
      component={ExamesSolicitados}
      showSideBar
      isPrivate
    />
    <Route path="/caixa" titulo="Caixa" component={Caixa} isPrivate />
    <Route
      path="/procedimento"
      titulo="Procedimentos"
      component={Procedimento}
      showSideBar
      isPrivate
    />
    <Route
      path="/agendaCadastro"
      titulo="Cadastro de Agendas"
      component={AgendaCadastro}
      isPrivate
      showSideBar
    />
    <Route
      path="/DiaNaoAgendar"
      titulo="Dia Não Agendar Global"
      component={DiaNaoAgendar}
      isPrivate
      showSideBar
    />
    <Route
      path="/agendaAtendimento"
      component={AgendaAtendimento}
      titulo="Atendimento"
      isPrivate
    />
    <Route
      path="/pacienteAtendimentoAlvaro/:id"
      component={PacienteAtendimentoAlvaro}
      isPrivate
    />
    <Route
      path="/pacienteAtendimento/:id"
      component={PacienteAtendimento}
      isPrivate
    />
    <Route
      path="/usuario"
      titulo="Usuários"
      component={Usuario}
      isPrivate
      showSideBar
    />
    <Route
      path="/perfil"
      titulo="Perfis"
      component={Perfil}
      isPrivate
      showSideBar
    />
    <Route
      path="/medico"
      titulo="Médicos"
      component={Medico}
      isPrivate
      showSideBar
    />
    <Route
      path="/cadastrocontrato"
      titulo="Contratos"
      component={CadastroContrato}
      isPrivate
      showSideBar
    />
    <Route
      path="/palavrasbloqueadas"
      titulo="Palavras Bloqueadas"
      component={PalavraBloqueada}
      isPrivate
      showSideBar
    />
    <Route
      path="/contratomedico/:id"
      titulo="Contrato Médico"
      component={ContratoMedico}
      isPrivate
      showHeader={false}
    />
    <Route
      path="/contratotratamento/:id"
      titulo="Contrato Tratamento"
      component={ContratoTratamento}
      isPrivate
      showHeader={false}
    />
    <Route
      path="/usuariosaniversariantes"
      titulo="Aniversariantes"
      component={AniversariantesUsuario}
      isPrivate
      showSideBar
    />
    <Route
      path="/modelodocumento"
      titulo="Modelo de Documentos"
      component={ModeloDocumento}
      isPrivate
      showSideBar
    />
    <Route
      path="/modelomensagem"
      titulo="Modelo de Mensagens"
      component={ModeloMensagem}
      isPrivate
      showSideBar
    />
    <Route
      path="/grupoExames"
      titulo="Grupo de Exames"
      component={GrupoExames}
      isPrivate
      showSideBar
    />
    <Route
      path="/configuracao"
      titulo="Administrativo"
      component={Configuracao}
      showSideBar
      isPrivate
    />
    <Route
      path="/whatsapp"
      titulo="Whatsapp"
      component={Whatsapp}
      showSideBar
      isPrivate
    />
    <Route
      path="/fechamentocaixa"
      titulo="Fechamento de Caixa"
      component={FechamentoCaixa}
      showSideBar
      isPrivate
    />
    <Route
      path="/fechamentodia"
      titulo="Fechamento do Dia"
      component={FechamentoDia}
      showSideBar
      isPrivate
    />
    <Route
      path="/fechamentoconferencia"
      titulo="Fechamento do Conferencia"
      component={FechamentoConferencia}
      showSideBar
      isPrivate
    />
    <Route
      path="/procedimentosrealizados"
      titulo="Procedimentos Realizados"
      component={ProcedimentosRealizados}
      showSideBar
      isPrivate
    />
    <Route
      path="/procedimentosrealizadosvalor"
      titulo="Procedimentos Realizados Valor"
      component={ProcedimentosRealizadosValor}
      showSideBar
      isPrivate
    />
    <Route
      path="/procedimentosrealizadosConvenio"
      titulo="Procedimentos Realizados Convênio"
      component={ProcedimentosRealizadosConvenio}
      showSideBar
      isPrivate
    />
    <Route
      path="/fechamentoterceiro"
      titulo="Procedimentos Realizados Valor"
      component={FechamentoParceiro}
      showSideBar
      isPrivate
    />
    <Route
      path="/consumocartao"
      titulo="Consumo por Cartão"
      component={ConsumoCartao}
      showSideBar
      isPrivate
    />
    <Route
      path="/quantidadeprocedimentos"
      titulo="Quantidade de Procedimentos"
      component={QuantidadeProcedimentos}
      showSideBar
      isPrivate
    />

    <Route
      path="/resumogerencial"
      titulo="Resumo Gerencial"
      component={ResumoGerencial}
      showSideBar
      isPrivate
    />

    <Route
      path="/resumocartaosaude"
      titulo="Resumo Cartão Saúde"
      component={ResumoCartaoSaude}
      showSideBar
      isPrivate
    />

    <Route
      path="/pagaroutraunidade"
      titulo="À Pagar Outra Unidade"
      component={PagarOutraClinica}
      showSideBar
      isPrivate
    />

    <Route
      path="/receberoutraunidade"
      titulo="À Receber Outra Unidade"
      component={ReceberOutraClinica}
      showSideBar
      isPrivate
    />

    <Route
      path="/encaminhamentos"
      titulo="Agendamentos com Encaminhamento"
      component={Encaminhamentos}
      showSideBar
      isPrivate
    />

    <Route
      path="/MedicoEncaminhamento"
      titulo="Médico para encaminhamento"
      component={MedicoEncaminhamento}
      showSideBar
      isPrivate
    />

    <Route
      path="/UnidadeSaudeEncaminhamento"
      titulo="Unidade de Saúde para encaminhamento"
      component={UnidadeSaude}
      showSideBar
      isPrivate
    />

    <Route
      path="/cartaosaudelistagem"
      titulo="Listagem Cartão Saúde"
      component={CartaoSaudeListagem}
      showSideBar
      isPrivate
    />

    <Route
      path="/despesas"
      titulo="Despesas"
      component={Despesas}
      showSideBar
      isPrivate
    />

    <Route
      path="/outrasreceitas"
      titulo="Outras Receitas"
      component={OutrasReceitas}
      showSideBar
      isPrivate
    />
    <Route
      path="/pagamentosMedicos"
      titulo="Pagamentos Médicos"
      component={PagamentoMedico}
      showSideBar
      isPrivate
    />
    <Route
      path="/consultarpagamentosMedicos"
      titulo="Consulta Pagamentos Médicos"
      component={DespesasPagamentoMedico}
      showSideBar
      isPrivate
    />

    <Route
      path="/impressaopagamentoMedico/:id"
      titulo="Impressão Pagamento Médico"
      component={ReciboImpressao}
      isPrivate
      showHeader={false}
    />

    <Route
      path="/notasfiscais"
      titulo="Nota Fiscal"
      component={Nota}
      showSideBar
      isPrivate
    />

    <Route
      path="/despesasresumo"
      titulo="Demonstrativo Despesas"
      component={DespesasResumo}
      showSideBar
      isPrivate
    />

    <Route
      path="/atrasados"
      titulo="Cobranças"
      component={Cobranca}
      isPrivate
      showSideBar
    />
    <Route
      path="/cobrancasrealizadas"
      titulo="Cobranças realizadas"
      component={CobrancasRealizadas}
      isPrivate
      showSideBar
    />
    <Route
      path="/resumocobrancas"
      titulo="Resumo Cobranças"
      component={ResumoCobrancas}
      isPrivate
      showSideBar
    />
    <Route
      path="/recebimentos31"
      titulo="Cobranças Recebidas mais de 31 dias"
      component={Cobrancas31}
      isPrivate
      showSideBar
    />
    <Route
      path="/recebimentosmes"
      titulo="Cobranças Recebidas Dentro Mês"
      component={CobrancasMes}
      isPrivate
      showSideBar
    />

    <Route
      path="/conferenciaexamesalvaro"
      component={ConferenciaExamesAlvaro}
      titulo="Conferencia Exames Alvaro"
      isPrivate
      showSideBar
    />

    <Route
      path="/lucroexamesalvaro"
      component={LucroExamesAlvaro}
      titulo="Lucro Exames Alvaro"
      isPrivate
      showSideBar
    />

    <Route
      path="/impressaodocumento/:id/:tipo"
      component={ImpressaoDocumento}
      titulo="Impressão de Documentos"
      isPrivate
      showHeader={false}
    />

    <Route
      path="/produtividade"
      component={Produtividade}
      titulo="Relatório de produtividade"
      isPrivate
      showSideBar
    />

    <Route
      path="/tratamentos"
      component={ListaOrcamentos}
      titulo="Orçamentos / Tratamentos"
      isPrivate
    />
    <Route path="/orcamento/:id" component={Orcamento} isPrivate />
    <Route
      path="/pacoteTratamento/add"
      component={PacoteTratamento}
      isPrivate
    />
    <Route
      path="/pacoteTratamento/edit/:id"
      component={PacoteTratamento}
      isPrivate
    />
    <Route
      path="/produtividadedetalhe"
      component={ProdutividadeDetalhe}
      titulo="Relatório de produtividade"
      isPrivate
      showSideBar
    />

    <Route
      path="/atendimentoparticular"
      component={AtendimentoParticular}
      titulo="Relatório de atendimentos particulares"
      isPrivate
      showSideBar
    />

    <Route
      path="/pacientebuscaavancada"
      component={PacienteBuscaAvancada}
      titulo="Busca Avançada de Pacientes"
      isPrivate
      showSideBar
    />

    <Route
      path="/dashboardagendamento"
      component={DashboardAgendamento}
      titulo="Dashboard de Agendamentos"
      isPrivate
      showSideBar
    />

    <Route
      path="/dashboardmedico"
      component={DashboardMedico}
      titulo="Dashboard Medico"
      isPrivate
      showSideBar
    />

    <Route
      path="/medicosagendamentos"
      component={MedicosAgendamentos}
      titulo="Medicos Agendamentos"
      isPrivate
      showSideBar
    />

    <Route
      path="/listaCombo"
      component={ListaCombo}
      titulo="Lista de Combos"
      isPrivate
    />

    <Route
      path="/AgendaCombo/edit/:AgeCodigo/:ConfCodigo"
      component={PacoteCombo}
      isPrivate
    />

    <Route
      path="/registrologinpordia"
      component={RegistroLoginDia}
      titulo="Registro de Logins por Dia"
      isPrivate
      showSideBar
    />

    <Route
      path="/listaesperaatendimento"
      component={ListaEsperaAtendimento}
      titulo="Lista de Espera para Atendimento"
      isPrivate
    />

    <Route
      path="/controlepainel"
      component={AgendaSalas}
      titulo="Controles Painel"
      isPrivate
      showSideBar
    />

    <Route
      path="/agendamentosrealizados"
      component={AgendamentosRealizadosDia}
      titulo="Agendamentos Realizados"
      isPrivate
      showSideBar
    />

    <Route
      path="/agendamentoswhatsapp"
      component={AgendamentosWhatsapp}
      titulo="Agendamentos WhatsApp"
      isPrivate
      showSideBar
    />

    <Route
      path="/pedidoexamesprocedimentos"
      component={PedidoExamesProcedimentos}
      titulo="Pedido de Exames Procedimentos"
      isPrivate
      showSideBar
    />

    <Route
      path="/pedidoexamesquantidadeprocedimentos"
      component={PedidoExamesQuantidadeProcedimentos}
      titulo="Pedido de Exames Quantidade Procedimentos"
      isPrivate
      showSideBar
    />

    <Route
      path="/pedidoexamesgerencial"
      component={PedidoExamesGerencialValor}
      titulo="Pedido de Exames Gerencial com Valores"
      isPrivate
      showSideBar
    />

    <Route
      path="/pedidoencaminhamentosquantidade"
      component={PedidoEncaminhamentoQuantidadeProcedimentos}
      titulo="Pedido de Encaminhamentos Quantidade"
      isPrivate
      showSideBar
    />

    <Route
      path="/pedidoencaminhamentosgerencial"
      component={PedidoEncaminhamentosGerencialValor}
      titulo="Pedido de Encaminhamentos Gerencial com Valores"
      isPrivate
      showSideBar
    />

    <Route
      path="/servicosnotafiscal"
      component={ServicosNF}
      titulo="Serviços Nota Fiscal"
      isPrivate
      showSideBar
    />

    <Route
      path="/monitorarbotwhatsapp"
      component={WhatsappBotPainel}
      titulo="Monitorar Bot Whatsapp"
      isPrivate
    />

    <Route path="/sempermissao" component={SemPermissao} isPrivate />

    {/* <Route path="/" component={() => <h1>404</h1>} isPrivate /> */}

    <Route path="*" component={Dashboard} isPrivate />
  </Switch>
);

export default Routes;
